import 'bootstrap/dist/css/bootstrap.min.css';
import { Nav } from 'react-bootstrap';

function Navbar() {
  return (
    <Nav
      className="px-3 py-2 justify-content-center"
      style={{
        backgroundColor: "#f1f3f5",   // soft light grey (not pure white)
        boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
        fontSize: "14px"
      }}
    >
      <Nav.Item>
        <Nav.Link href="#/home" className="text-dark fw-semibold px-3">
          HOME
        </Nav.Link>
      </Nav.Item>

      <Nav.Item>
        <Nav.Link href="#/create" className="text-dark fw-semibold px-3">
          CREATE
        </Nav.Link>
      </Nav.Item>

      <Nav.Item>
        <Nav.Link href="#/deposite" className="text-dark fw-semibold px-3">
          DEPOSIT
        </Nav.Link>
      </Nav.Item>

      <Nav.Item>
        <Nav.Link href="#/withdraw" className="text-dark fw-semibold px-3">
          WITHDRAW
        </Nav.Link>
      </Nav.Item>

      <Nav.Item>
        <Nav.Link href="#/alldata" className="text-dark fw-semibold px-3">
          ALL DATA
        </Nav.Link>
      </Nav.Item>
    </Nav>
  );
}

export default Navbar;
